import { CurrenciesConversions } from '@etoh/database/core';
import { isNumber } from 'lodash';

const convertCurrencyToUSD_CACHE = new Map<string, number>();

// assume currenciesConversion is sorted by date
export const findCurrencyRate = (
  currenciesConversions: CurrenciesConversions[],
  date: string,
  currency: string
): number => {
  // find the closest date and fastest way to do it
  let left = 0;
  let right = currenciesConversions.length - 1;
  let mid = 0;
  while (left <= right) {
    mid = Math.floor((left + right) / 2);
    if (currenciesConversions[mid].date < date) {
      left = mid + 1;
    } else if (currenciesConversions[mid].date > date) {
      right = mid - 1;
    } else {
      break;
    }
  }

  return currenciesConversions[mid].currencies[currency];
};

export const convertCurrencyToUSD = (
  currenciesConversions: CurrenciesConversions[],
  date: string,
  currency: string,
  amount: number
): number => {
  if (!isNumber(amount) || !currency || !date) {
    console.warn('No amount or currency or date', amount, currency, date);
    return 0;
  }

  if (!currenciesConversions || currenciesConversions.length === 0) {
    console.error('No currency conversions');
    return amount;
  }

  if (currency === 'USD') {
    console.log('Currency is USD, no need to convert');
    return amount;
  }

  const dayDate = date.split('T')[0];
  const key = `${dayDate}-${currency}`;
  let rate: undefined | number = undefined;
  if (convertCurrencyToUSD_CACHE.has(key)) {
    // console.log(`Currency rate ${date} for ${currency} is cached`);
    rate = convertCurrencyToUSD_CACHE.get(key) as number;
  } else {
    rate = findCurrencyRate(currenciesConversions, date, currency);
    convertCurrencyToUSD_CACHE.set(key, rate);
  }

  const convertedAmountToUsd = amount / rate;
  /*
  console.log(
    `Currency rate ${date} for ${currency} is ${rate}, converted amount ${amount} to USD is ${convertedAmountToUsd}`
  );
  */
  return convertedAmountToUsd;
};
